<template>
  <div class="d-flex align-items-center">
    <button
      class="add-sites-kiosks cursor-pointer"
      :disabled="disableIfStandAlone"
      @click="setData({})"
      v-b-modal="'addSite_'"
    >
      {{ $t("sitesAndDevices.addSite") }}
    </button>
    <b-modal
      :id="'addSite_' + (getHideSiteModal ? 'hide' : '')"
      class="wee"
      size="lg"
      scrollable
      hide-footer
      hide-header
    >
      <SiteForm @createNewSite="createNewSite" @updateSite="updateSite" />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SiteForm from "@/components/sites/SiteFormForTreeList";
import sitesService from "@/services/sites";

export default {
  components: {
    SiteForm,
  },
  props: ["disableIfStandAlone"],
  mounted() {
    this.$store.commit("sites/setHideSiteModal", false);
  },
  computed: {
    ...mapGetters("sites", ["getHideSiteModal"]),
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    async createNewSite(form) {
      await sitesService.createSite(form);
      this.$emit("siteCreated");
      this.$bvModal.hide("addSite_");
      this.$toast.success("Site Added");
    },
    async updateSite(siteData) {
      await sitesService.updateSite(siteData);
      this.$emit("siteUpdated");
      this.$bvModal.hide("addSite_");
      this.$toast.success("Site Updated");
    },
  },
};
</script>
<style lang="scss">
#addSite_hide___BV_modal_content_ {
  display: none;
}
.add-sites-kiosks {
  border: none;
  border-radius: 13.5px;
  background: #103f5e;
  color: #fff;
  width: 127px;
  height: 27px;

  font-size: 16px;

  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-sites-kiosks:disabled {
  opacity: 0.4 !important;
}
.custom-kiosk-add {
  background: #103f5e !important;
  border-radius: 13.5px;
  width: 127px;
  height: 27px;
  display: flex;
  align-items: center;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #ffffff !important;
  .btn-secondary {
    display: flex;
    align-items: center;

    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    justify-content: center;
    color: #ffffff !important;
    width: 127px !important;
    height: 27px !important;
    background: #103f5e !important;
    border: none;
    border-radius: 13.5px;
  }
  ul.dropdown-menu.show {
    li.red-remove a {
      color: #f46a6a !important;
      padding-bottom: 10px !important;
    }
    align-items: center !important;
    background: #ffffff !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 6px !important;
    text-align: center !important;
    min-width: 127px !important;
    max-height: 179px !important;
    margin-top: 6px !important;
    // overflow-y: scroll;
  }
  a.dropdown-item {
    margin: auto !important;

    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    text-align: center !important;
    color: #787878 !important;
    padding-inline-end: 24px !important;
  }
  a[aria-disabled="true"] {
    opacity: 0.4;
  }
}
</style>
